import { create } from "zustand";

type FormStore = {
  name: string;
  phone: string;
  email: string;
  text: string;
  setField: (field: keyof FormStore, value: string) => void;
  reset: () => void;
};

const useFormStore = create<FormStore>((set) => ({
  name: "",
  phone: "",
  email: "",
  text: "",
  setField: (field, value) => set({ [field]: value }),
  reset: () => set({ name: "", phone: "", email: "", text: "" }),
}));

export default useFormStore;
